import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import GoSvgColor from '../assets/go.svg';

export const GoColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-go" className={cx('sdkIcon', className)} size={size} {...props}>
    <GoSvgColor />
  </LegacyIcon>
);
